import * as R from 'ramda';


/**
 * Returns whether or not this browser is able to give us the list of connected webcams.
 * We do this strange window check so that unit tests can run inside a terminal/IDE where there is no window object.
 */
export const canEnumerateCameras = (typeof window === 'undefined')
                                   ? false
                                   : R.path([ 'mediaDevices', 'enumerateDevices' ], navigator);


/**
 * Returns whether or not this browser is able to give us a camera stream from a connected webcam
 */
export const canGetStream = (window: Window) => {
  const navigator = window.navigator;

  return !!(
    (navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
    // @ts-ignore
    || navigator.getUserMedia
    // @ts-ignore
    || navigator.webkitGetUserMedia
    // @ts-ignore
    || navigator.mozGetUserMedia
    // @ts-ignore
    || navigator.msGetUserMedia
    // @ts-ignore
    || window.getUserMedia
  );
};


/**
 * Convert the IE Camera polyfill to a promise so that it's consistent with the WebRTC contract.
 */
// @ts-ignore
const getUserMediaIe = (options) => new Promise((resolve, reject) => window.getUserMedia(options, resolve, reject));


/**
 * Using the given camera options, retrieves a camera stream or error for you (as a promise).
 */
export const getStream = (navigator: Navigator, options, getUserMediaPolyfill = getUserMediaIe) => {
  if ((navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
    return navigator.mediaDevices.getUserMedia(options);
  }

  // @ts-ignore
  const getUserMediaCompat = navigator.getUserMedia
                             // @ts-ignore
                             || navigator.webkitGetUserMedia
                             // @ts-ignore
                             || navigator.mozGetUserMedia
                             // @ts-ignore
                             || navigator.msGetUserMedia
                             // @ts-ignore
                             || getUserMediaPolyfill; // Uses IE Polyfill

  // @ts-ignore
  return getUserMediaCompat(options);
};
